module.exports = __webpack_public_path__ + "assets/img/03.c287527d.png";